const baseUri = 'notifications';

export default {

  sendOrderClientSummary(orderId, email) {
    const data = {
      order_id: orderId,
      email,
    };

    return api.post(`${baseUri}/order-client-summary`, data);
  },
};



// WEBPACK FOOTER //
// ./src/js/api/notifications.js